exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_object-gops.js
// module id = 59
// module chunks = 0